import React from 'react';

import {Assertion} from '@udemy/badging';
import {Tracker} from '@udemy/event-tracking';
import {useI18n} from '@udemy/i18n';
import {Icon} from '@udemy/icons';
import {Dropdown} from '@udemy/react-menu-components';

import {BadgeAssertionSharedEvent, SHARE_DESTINATIONS} from '../../features/events';
import {buildAddToLinkedInUrl} from '../../lib/linkedin';
import styles from './add-to-linkedin-menu-item.module.less';

export const AddToLinkedInMenuItem: React.FC<{assertion: Assertion}> = ({assertion}) => {
    const {gettext} = useI18n();

    return (
        <Dropdown.MenuItem
            onClick={() => {
                Tracker.publishEvent(
                    new BadgeAssertionSharedEvent(
                        assertion.badgeClass,
                        SHARE_DESTINATIONS.LINKEDIN_CERTIFICATION,
                    ),
                );
                window.open(buildAddToLinkedInUrl(assertion), '_blank', 'noopener,noreferrer');
            }}
            data-testid="add-to-linkedin-item"
        >
            <span className={styles['menu-item']}>
                <Icon glyph="linkedin" size="small" color="inherit" label="" aria-hidden="true" />
                <span>{gettext('Add to LinkedIn profile')}</span>
            </span>
        </Dropdown.MenuItem>
    );
};
